import { render } from "./application-logo.vue?vue&type=template&id=f766787e"
import script from "./application-logo.vue?vue&type=script&lang=js"
export * from "./application-logo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__